import * as ChartJs from 'chart.js';

const charts = Object.values(ChartJs).filter(chartClass => (chartClass.id));

ChartJs.Chart.register(charts);
